import { LogErrors } from './../../../LogErrors'

import { ValidateAccessCode as DLValidateAccessCode } from './../../../DL/Student/SignUp/SignUp'
import { ValidateSqlInjection } from './../../Security'
import { AddToGroup as DLAddToGroup, CreateAccountAndAddToGroup as DLCreateAccountAndAddToGroup } from './../../../DL/Student/SignUp/SignUp'


const IsValideCode = async (accessCode) => {
    try {
        // Códigos brindados por Fer 02/Nov/2025. Actualizados el 06/Nov/2025. Actualizados el 02/Feb/2026. Actualizados el 04/Feb/2026. Actualizados el 17/Feb/2026.
        const invalideCodes = ['CLV2TV','CLVWVB','CLVQRR','CAMPV9','CAMDDJ','CAMT05','CASY4U','CASEIC','CASWXC','HMDHAF','HMD3J3','CICXYH','CICZWV','CICHEN','CICC7O','CICVGG','CMG5QS','CMGZ0A','CMGATB','CMGW2W','CMGLJE','CTL9UX','PTBLHH','PTBZ4X','PTBYLU','PTBMZ9','PTBRVG','PTBWM3','PTSIBS','CVMM8W','CVMC1N','CVMUAX','CVM733','CVM9U7','AME1UT','AME3JE','AMEPOZ','AMECNP','AME6NH','IMRJDM','IMR0EU','IMRXZW','AGU9TV','AGU69A','AGUK41','AVSNI3','IRBFRE','IRBNMI','IRBU3N','IRBZDK','IRBPHM','IRSSJG','IRSF1F','IRSDEI','IRSGHS','IRSZMJ','IRSXAM','CMGNMR','UKAZ3C','UKACIE','UKAQPJ','LBEPNY','LBEL9U','LBEY0J','LBE0NL','LBEN0N','LBEF5N','LBEUMX','LBEPR4','LBEU0D','LBEMYE','LBELNF','LBESMU','LBET5E','LBEYN6','LBE0JH','LBENKC','UKAKZ4']
        
        if (invalideCodes.includes(accessCode.toUpperCase())) {   
            return false
        } else {
            return true
        }
    } catch (error) {
        return false
    }
}

const ValidateAccessCode = async (accessCode) => {
    try {
        if (accessCode) {
            const code = accessCode.trim()

            if (code === '') {
                return { success: false, message: 'Escribe el código Ztudia' }
            }

            // Validación de la info del cuadro de texto
            const regex = /^[a-z0-9]+$/
            
            if (!regex.test(code.toLowerCase())) {
                return { success: false, message: 'El código Ztudia contiene caracteres no permitidos.' }
            } else if (await ValidateSqlInjection(code)) {
                return { success: false, message: 'El código Ztudia que escribiste no es válido.' }
            } else if (!await IsValideCode(accessCode)) {
                return { success: false, message: '¡Ups! El grupo al que intentas unirte ya no acepta nuevos registros. Consulta con tu instructor si necesitas más información.' }
            }
            
            const response = await DLValidateAccessCode(accessCode)
            
            if (response.success) {
                return { success: true, data: response.data }
            } else {
                return { success: false, message: response.message }
            }
        } else {
            return { success: false, message: 'Escribe el código Ztudia' }
        }
    } catch (error) {
        await LogErrors('',error)
        return { success: false, message: 'No ha sido posible validar tu código Ztudia. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const CreateAccount = async (accountData) => {
    try {
        const regex = /^[a-z0-9]+$/
        const regexNames = /^[a-záéíóúüñ ]+$/
        
        if (!accountData.accessCode && !accountData.username && !accountData.name && !accountData.lastName) {
            return { success: false, message: 'Ingresa los datos para crear tu cuenta Ztudia' }
        }
        
        const accessCode = accountData.accessCode.trim()
        const username = accountData.username.trim()
        const name = accountData.name.trim()
        const lastName = accountData.lastName.trim()
        
        if (accessCode) {
            if (!regex.test(accessCode.toLowerCase())) {
                return { success: false, message: 'El código Ztudia contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(accessCode)) {
                return { success: false, message: 'El código Ztudia que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'El código Ztudia es obligatorio' }
        }
        
        if (username) {
            if (!regex.test(username.toLowerCase())) {
                return { success: false, message: 'El usuario que escribiste contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(username)) {
                return { success: false, message: 'El usuario que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'Ingresa tu usuario' }
        }
        
        if (name) {
            if (!regexNames.test(name.toLowerCase())) {
                return { success: false, message: 'El nombre que escribiste contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(name)) {
                return { success: false, message: 'El nombre que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'Ingresa tu(s) nombre(s)' }
        }
        
        if (lastName) {
            if (!regexNames.test(lastName.toLowerCase())) {
                return { success: false, message: 'El apellido que escribiste contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(lastName)) {
                return { success: false, message: 'El apellido que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'Ingresa tu(s) apellido(s)' }
        }
        
        const response = await DLCreateAccountAndAddToGroup(accessCode, username, name, lastName)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('CreateAccount - BL SignUp',error)
        return { success: false, message: 'No ha sido posible crear tu cuenta y asociarte al grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const AddToGroup = async (accountData) => {
    try {
        const regex = /^[a-z0-9]+$/
        const regexPassword = /[a-z0-9!@#$%^&*()\-=+[\]{}|:'",.<>?/`~]/
        
        if (!accountData.accessCode && !accountData.username && !accountData.password) {
            return { success: false, message: 'Ingresa tu usuario y contraseña' }
        }
        
        const accessCode = accountData.accessCode.trim()
        const username = accountData.username.trim()
        const password = accountData.password.trim()
        
        if (accessCode) {
            if (!regex.test(accessCode.toLowerCase())) {
                return { success: false, message: 'El código Ztudia contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(accessCode)) {
                return { success: false, message: 'El código Ztudia que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'El código Ztudia es obligatorio' }
        }
        
        if (username) {
            if (!regex.test(username.toLowerCase())) {
                return { success: false, message: 'El usuario que escribiste contiene caracteres no permitidos' }
            } else if (await ValidateSqlInjection(username)) {
                return { success: false, message: 'El usuario que escribiste no es válido' }
            }
        } else {
            return { success: false, message: 'Ingresa tu usuario' }
        }
        
        if (password) {
            if (password.length >= 8) {
                if (!regexPassword.test(password.toLowerCase())) {
                    return { success: false, message: 'La contraseña que escribiste contiene caracteres no permitidos' }
                } else if (await ValidateSqlInjection(password)) {
                    return { success: false, message: 'La contraseña que escribiste no es válida' }
                }
            } else {
                return { success: false, message: 'La contraseña que escribiste no es válida' }
            }
        } else {
            return { success: false, message: 'Ingresa tu contraseña' }
        }
        
        const response = await DLAddToGroup(accessCode, username, password)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('AddToGroup - BL SignUp',error)
        return { success: false, message: 'No ha sido posible asociarte al grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

export { ValidateAccessCode, CreateAccount, AddToGroup };